export default {
   user: null,
   special_customer: null,
   access_token: null,
   is_logged: false,
   logged_at: null,
   is_csf: false,
 }